// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

// ANTD
import notification from 'antd/lib/notification';

// APOLLO
import { graphql, compose } from 'react-apollo';
import currentUserQuery from 'ApolloClient/Queries/currentUser';
import GET_PAYPAL_AUTH_TOKEN_FROM_CODE from 'ApolloClient/Mutations/getPaypalAuthTokenFromCode';

/**
 * Once a user has given permissions on the consent page, Paypal will redirect
 * the page to the redirect URL you have provided with a code query parameter.
 */
class PaypalAuthCallbackPage extends React.Component {
  postMutationUpdate = (proxy, { data }) => {
    // get the most current local version of data
    let localData = proxy.readQuery({
      query: currentUserQuery,
    });

    // the updated versin of the data that we'll eventually use to update the apollo cache
    let newData = {
      ...localData,
      currentUser: {
        ...localData.currentUser,
        paypalSet: true,
      },
    };

    proxy.writeQuery({
      query: currentUserQuery,
      data: {
        ...newData,
      },
    });
  };

  async componentWillMount() {
    const { location, history, getPaypalAuthTokenFromCode } = this.props;

    // Get token from url params
    // const token = (match && match.params && match.params.token) || '';
    const { code } = qs.parse(location.search);

    console.log('CODE', code);

    try {
      await getPaypalAuthTokenFromCode({
        variables: { code },
        update: this.postMutationUpdate,
        // refetchQueries: [{ query: currentUserQuery }],
      });
      notification.success({ message: 'You successfully connected your PayPal!' });
      history.push('/app/studio#payments');
    } catch (exc) {
      console.log(exc);
      notification.error({ message: exc });
    }
  }

  render() {
    return <div>Loading...</div>;
  }
}

PaypalAuthCallbackPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  getPaypalAuthTokenFromCode: PropTypes.func.isRequired,
};

const enhance = compose(
  withRouter,
  graphql(GET_PAYPAL_AUTH_TOKEN_FROM_CODE, { name: 'getPaypalAuthTokenFromCode' }),
);

// withRouter provides access to match.params and history.push()
export default enhance(PaypalAuthCallbackPage);



// WEBPACK FOOTER //
// ./src/routes/app-paypal-auth-callback/index.js